import { useEffect, useState } from "react";
const useIntersectionObserver = (containerRef, targetElementRef) => {
  const [elementIsVisible, setElementIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setElementIsVisible(!entry.isIntersecting);
      },
      { threshold: 0.9, root: containerRef.current }
    );
    const indicatorElement = targetElementRef.current;
    if (indicatorElement) {
      observer.observe(indicatorElement);
    }
    return () => {
      if (indicatorElement) {
        observer.unobserve(indicatorElement);
      }
    };
  }, [containerRef, targetElementRef]);
  return elementIsVisible;
};
export default useIntersectionObserver;
